import { render, staticRenderFns } from "./google-wrapper.vue?vue&type=template&id=08a2a8c6&"
import script from "./google-wrapper.vue?vue&type=script&lang=js&"
export * from "./google-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports